import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export const SaveDecisionTplDialog = ({ open, onOpenChange, defaultTitle, editing, onSave }) => {
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open) setTitle(editing?.title || defaultTitle || ""); }, [open, editing, defaultTitle]);
  const run = async (mode) => {
    setBusy(mode);
    try { await onSave(title.trim(), mode === "update" ? editing : null); onOpenChange(false); } finally { setBusy(""); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" dir="rtl" data-testid="decision-tpl-save-dialog">
        <DialogHeader className="text-right">
          <DialogTitle>حفظ كنموذج ثابت</DialogTitle>
          <DialogDescription>يُحفظ النوع والنص الحالي، ويُستبدل اسم الموظف ورقم الإقامة والتاريخ بخانات تتعبأ تلقائياً عند كل استخدام.</DialogDescription>
        </DialogHeader>
        <label className="text-xs font-semibold text-slate-500">اسم النموذج</label>
        <Input data-testid="decision-tpl-name" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="مثال: إنذار أول - تأخير" />
        <div className="flex flex-wrap gap-2 pt-2">
          {editing && (
            <Button data-testid="decision-tpl-update" disabled={!title.trim() || !!busy} onClick={() => run("update")} className="gap-1.5 bg-amber-600 hover:bg-amber-700">
              {busy === "update" && <Loader2 className="h-4 w-4 animate-spin" />} تحديث «{editing.title}»
            </Button>
          )}
          <Button data-testid="decision-tpl-create" variant={editing ? "outline" : "default"} disabled={!title.trim() || !!busy} onClick={() => run("new")} className="gap-1.5">
            {busy === "new" && <Loader2 className="h-4 w-4 animate-spin" />} حفظ كنموذج جديد
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
